// Copyright 2022, Imprivata, Inc.  All rights reserved.

import { useMutation } from '@tanstack/react-query';
import type { CallerStatusResponse, OpenServiceDeskLinkRequest } from '../../models/service-desk';
import { apiClient } from '../client';

// The service desk route renders outside PlatformProvider so the caller always reaches P8 even if
// the coding-context bootstrap fails. The body is a plain link ID (no PII), so no coding context
// is needed.
const openServiceDeskLinkRequest = (linkId: string): Promise<CallerStatusResponse> => {
  const request: OpenServiceDeskLinkRequest = { linkId };
  return apiClient.postWithoutCodingContext<CallerStatusResponse>('servicedesk/open', request);
};

export const useOpenServiceDeskLinkMutation = () => {
  const mutation = useMutation({
    mutationFn: (linkId: string) => openServiceDeskLinkRequest(linkId),
  });

  // The promise settles on its own. Callers must not rely on the mutation's observer state: React
  // StrictMode (src/index.tsx) detaches the observer from an in-flight mutation on its simulated
  // unmount, so isError/isSuccess would never update in development.
  return { openLink: mutation.mutateAsync };
};
